import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessDesigner from "../ProcessDesigner/ProcessDesigner";

import { getLabel } from "../../tools/Dictionary";

import { MdDesignServices } from "react-icons/md";


const AdminProductProcessModal = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;
  const Process = props.Process;

  //State
  const [loading] = useState(false);
  const [designer, setDesigner] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "800px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {designer &&
          <ProcessDesigner
            IsDesktop={IsDesktop}
            ReadOnly={true}
            ProcessId={Process._id}
            Title={Process.code}
            OnClose={() => setDesigner(false)}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("AdminProduct", ReadOnly ? "Troubleshooting Process" : "Confirm selection")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "code")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input"}
                value={Process.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Process", "description")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "500px" }} >
              <textarea
                className={"page_textarea_input"}
                rows={3}
                value={Process.description || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesigner", "Process")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <div className="page_button page_button_design" onClick={() => setDesigner(true)}>
                <div className="page_button_design_logo">
                  <MdDesignServices />
                </div>
                <div className="page_button_design_text">
                  {getLabel("AdminProduct", "Display Process")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) && 
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={(loading && !OnConfirm) ? undefined : OnConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default AdminProductProcessModal